import React, {useContext} from "react";
import HelpComponent from "components/HelpComponent";
import CPVInput from "components/CPVInput";
import FormTranslationContext from "context/FormTranslationContext";
import CPVSingleInput from "components/CPVSingleInput";

function NoticeCpvInput
({
     id,
     label,
     formikProps,
     disabled,
     required,
     multiple
 }) {
    const {formTr, formTip} = useContext(FormTranslationContext)
    const tip = formTip(label ? label : id);


    const input = multiple ? <CPVInput
        formikProps={formikProps}
        id={id}
        required={required}
        label={formTr(label ? label : id)}
        skipCheckTouched
        disabled={disabled}
    /> : <CPVSingleInput
        formikProps={formikProps}
        id={id}
        required={required}
        label={formTr(label ? label : id)}
        skipCheckTouched
        disabled={disabled}
    />

    if (tip)
        return <HelpComponent text={tip}>
            {input}
        </HelpComponent>
    return input;


}

export default NoticeCpvInput;